/** The tab that holds an in-page anchor of the data reference. */
export function tabOfHash(hash) {
  let id = String(hash ?? '').replace(/^#/, '');
  try { id = decodeURIComponent(id); } catch { /* keep the raw text */ }
  if (!id) return null;
  if (id.startsWith('source-')) return 'sources';
  if (id === 'field-naming') return 'naming';
  if (id === 'field-mapping') return 'mapping';
  return 'guide';
}

const NOT_IN_GUIDE = new Set(['field-naming', 'field-mapping']);

/** The table-of-contents groups for one tab: the guide minus the two schema sections, the sources, or none. */
export function tocGroupsFor(tab, groups) {
  if (tab === 'guide') return groups.slice(0, 1).map((g) => ({ ...g, entries: g.entries.filter((e) => !NOT_IN_GUIDE.has(e.id)) }));
  if (tab === 'sources') return groups.slice(1);
  return [];
}
